import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Notification from "../../elements/notification/Notification";
import RetryCallbackButton from "../../elements/retryCallbackButton/RetryCallbackButton";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { useHistory } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PayoutDetailsContent from "./PayoutDetailsContent";
import { AppContext } from "../../../App";
import { useTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import PayoutLogsContainer from "./PayoutLogsContainer";
import queryString from "query-string";
import { HTTP_STATUSES, PAYMENT_SYSTEM } from "../../../utils/consts";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledPayoutDetailsTabsWrapper, StyledPayoutDetailsWrapper } from "../styledPayout";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";

const DEFAULT_TAB = "";

const PayoutDetailsContainer = ({ match }) => {
  const { t } = useTranslation("transactionDetailsPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const { user } = useContext(AppContext);

  let [payout, setPayout] = useState(null);
  const [transferUserEmail, setTransferUserEmail] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchPayout = async () => {
    let responsePayout = null;

    await axios.get("/api/payouts/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setPayout(response.data);
        responsePayout = response.data;
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });

    return responsePayout;
  };

  const fetchTransferDetails = (responsePayout) => {

    if (!responsePayout || responsePayout.paymentSystem.subName !== PAYMENT_SYSTEM.BALANCE_TRANSFER) {
      return;
    }

    axios.get(`/api/transfers?payout.referenceId=${responsePayout.referenceId}`, userAuthenticationConfig()).
      then(response => {
        if (response.status === HTTP_STATUSES.HTTP_OK && response.data["hydra:member"][0]) {
          setTransferUserEmail(response.data["hydra:member"][0]?.payment?.connection?.project?.user?.email);
        }
      }).
      catch(error => {
        setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
      });
  };

  const fetchPayoutTransactionOrPayoutTransfer = () => {
    fetchPayout().then(responsePayment => {
      fetchTransferDetails(responsePayment);
    });
  };

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "systemLogs": {
        return 1;
      }
      case "serviceLogs": {
        return 2;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      if (newValue === "") {
        history.push(`/payouts/${payout.id}`);
        return;
      }

      history.push("?currentTab=" + newValue);
    }
  };

  //TODO Add pusher
  useEffect(() => {
    fetchPayoutTransactionOrPayoutTransfer();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{t("meta.payoutTitle")}</title>
        </Helmet>
        <StyledPayoutDetailsWrapper>
          <div className="payout-details-head">
            <GoToBackButton
              handler={() => {history.goBack();}}
            />
            <RetryCallbackButton
              id={match.params.id}
              type="payouts"
              setNotification={setNotification}
              notification={notification}
            />
          </div>
          <StyledPayoutDetailsTabsWrapper>
            <StyledTabsHead className="tab-head">
              <h4 className="tab-head__title">
                {t("tabs.titlePayout")}
              </h4>
              <Tabs
                value={queryParams?.currentTab ?? DEFAULT_TAB}
                indicatorColor="secondary"
                onChange={handleChange}
                orientation="vertical"
                className="tab-head-buttons"
              >
                <Tab label={t("tabs.transactionInfo")} value="" />
                <Tab label={t("tabs.systemLogs")} value="systemLogs" />
                <Tab label={t("tabs.serviceLogs")} value="serviceLogs" />
              </Tabs>
            </StyledTabsHead>
            <StyledTabsBody className="tab-body">
              <TabPanel
                value={tabValue}
                index={0}
              >
                <PayoutDetailsContent
                  payout={payout}
                  transferUserEmail={transferUserEmail}
                />
              </TabPanel>
              <TabPanel
                value={tabValue}
                index={1}
              >
                <PayoutLogsContainer transactionId={match.params.id}  type="systemLogs" />
              </TabPanel>
              <TabPanel
                value={tabValue}
                index={2}
              >
                <PayoutLogsContainer transactionId={match.params.id} service={payout?.connection.service.name} type="serviceLogs" />
              </TabPanel>
            </StyledTabsBody>
          </StyledPayoutDetailsTabsWrapper>
        </StyledPayoutDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default PayoutDetailsContainer;